export const SkilledTutors = [
  {
    name: "Rashmi",
    expertise: "Cooking & Embroidery",
    description:
      "Combining 6 years of teaching experience in cooking and embroidery, I help students master culinary skills and creative embroidery techniques. My classes focus on practical learning, fostering both creativity and confidence in students to excel.",
    feedback: "92% Positive Feedback",
    image: "tutor-1.png",
  },
  {
    name: "Syed Ahmad",
    expertise: "English Teacher",
    description:
      "With 7 years of experience in teaching English, I focus on improving grammar, vocabulary, and communication skills. My lessons are tailored to individual needs, ensuring students excel in both academic and real-world settings.",
    feedback: "92% Positive Feedback",
    image: "tutor-2.png",
  },
  {
    name: "Chandani Goyal",
    expertise: "Dance Teacher",
    description:
      "I bring 8 years of experience in teaching various dance styles. My lessons are energetic and focused on rhythm, expression, and technique, helping students build confidence and passion for dance, whether for performance or fitness.",
    feedback: "92% Positive Feedback",
    image: "tutor-3.png",
  },
  {
    name: "Rajitha Singh",
    expertise: "Inter Teacher",
    description:
      "As an intermediate teacher with 6 years of experience, I guide students through crucial academic years, focusing on subjects like math, science, and humanities. My goal is to build a strong foundation, ensuring success in exams and future studies.",
    feedback: "92% Positive Feedback",
    image: "tutor-4.png",
  },
  {
    name: "Nupur Singh",
    expertise: "Maths Teacher",
    description:
      "I have been teaching math for over 10 years, helping students understand complex concepts easily. My focus is on breaking down tough problems and making learning fun. I aim to build confidence in students and improve their grades with personalized attention.",
    feedback: "92% Positive Feedback",
    image: "tutor-5.png",
  },
  {
    name: "Naina Sinha",
    expertise: "Music Teacher",
    description:
      "I bring 6 years of experience in teaching various instruments and vocal techniques. My lessons are designed to inspire creativity and passion for music, helping students develop their talents, whether for personal enjoyment or academic success.",
    feedback: "92% Positive Feedback",
    image: "tutor-6.png",
  },
  {
    name: "Sai Pradeep",
    expertise: "Music Teacher",
    description:
      "With 7 years of teaching physics, I simplify complex theories and focus on hands-on learning. My approach emphasizes problem-solving and conceptual clarity, ensuring students not only improve their grades but also enjoy learning physics in Effective manner.",
    feedback: "92% Positive Feedback",
    image: "tutor-7.png",
  },
  {
    name: "Sohini singhal",
    expertise: "Yoga Teacher",
    description:
      "I teach yoga and aerobics with 5 years of experience, focusing on enhancing physical fitness, flexibility, and mental well-being. My sessions are designed for all levels, helping students stay active, reduce stress, and maintain a balanced lifestyle in an effective manner.",
    feedback: "92% Positive Feedback",
    image: "tutor-8.png",
  },
];
